import { TUpdateBusinessAreaRequest } from '~/app-modules/business-area/clients/dto/update-business-area-request';
import { TCreateBusinessAreaRequest } from '~/app-modules/business-area/clients/dto/create-business-area-request';
import { BusinessAreaClient } from '~/app-modules/business-area/clients/business-area-client';

@singleton()
export class BusinessAreaService {
  constructor(protected businessAreaClient: BusinessAreaClient) {}

  getById(id: string) {
    return this.businessAreaClient.getById(id);
  }

  getAvailableForCurrentUser() {
    return this.businessAreaClient.getAvailableForCurrentUser();
  }

  update(updateBusinessAreaRequest: TUpdateBusinessAreaRequest) {
    return this.businessAreaClient.update(updateBusinessAreaRequest);
  }

  create(createBusinessAreaRequest: TCreateBusinessAreaRequest) {
    return this.businessAreaClient.create(createBusinessAreaRequest);
  }
}
